import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { MultilineInput } from "@Components/Input/MutlilineInput"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React, { useEffect, useState } from "react"
import { View } from "react-native"
import { handleSetTextResponsesPayload } from "./QuestionLogic"

export const QuestionMultiline = (props) => {
    const { question, questionNumber, questionId, setPayload, userResponse, isResult, responses } = props
    const [value, setValue] = useState("")
    const handleSetValue = (text) => {
        setValue(text)
        handleSetTextResponsesPayload({ questionId, setPayload, responseValue: text })
    }

    useEffect(() => {
        if (userResponse?.id > 0 && isResult) {
            setValue(userResponse?.userResponse)
        } else {
            setValue("")
        }
    }, [userResponse, isResult])

    return (
        <View style={{ marginBottom: 50 }}>
            <OpenSansText fontWeight="bold" color={baseColors.orange.primary}>{`QUESTION N° ${
                questionNumber ?? 1
            } `}</OpenSansText>
            <OpenSansText style={{ marginTop: 10 }} fontSize={16}>
                {question ?? "Utilisez du texte pour répondre à cette question. Pas de bouton."}
            </OpenSansText>

            <Spacer height={20} />

            <MultilineInput disabled={isResult} height={80} value={value} onChange={handleSetValue} />

            {isResult && (
                <View style={{ flexDirection: "row", marginTop: 10 }}>
                    <OpenSansText style={{ fontStyle: "italic", color: "green", fontWeight: "bold" }} fontSize={14}>
                        La bonne réponse :
                    </OpenSansText>

                    <OpenSansText style={{ fontStyle: "italic", marginLeft: 10 }} fontSize={14}>
                        {userResponse?.correctResponse}
                    </OpenSansText>
                </View>
            )}
        </View>
    )
}
